/** @format */

import {Navigate, Route, Routes} from 'react-router-dom';

import {ROUTES} from 'constants/ROUTES';

import PrivateRoute from 'components/PrivateRoute';

import Summary from './Summary';
import Staff from './Staff';
import WideLayout from '../../layouts/WideLayout';
import Header from './Header';
import {ChiefReportProvider} from './context';

const Home = () => {
  return (
    <ChiefReportProvider>
      <WideLayout>
        <Header />
        <Routes>
          <Route
            path={`${ROUTES.CHIEF_REPORT_SUMMARY}/*`}
            element={
              <PrivateRoute>
                <Summary />
              </PrivateRoute>
            }
          />
          <Route
            path={`${ROUTES.CHIEF_REPORT_STAFF}/*`}
            element={
              <PrivateRoute>
                <Staff />
              </PrivateRoute>
            }
          />
          <Route index element={<Navigate to={ROUTES.CHIEF_REPORT_SUMMARY} />} />
        </Routes>
      </WideLayout>
    </ChiefReportProvider>
  );
};

export default Home;
